import { createSaleOrder,createProfessionSaleOrder } from "@/apis/market";
import { useConfigContext } from "@/app";
import { OrderType, Payments } from "@/constants";
import { StateReducer, useCreateReducer } from "@/libs/reducer";
import { useGlobalVerify } from "@/logic/verify";
import { useCryptoMerchant } from "@/stores/CryptoTradingStore";
import { useUserInfoStore } from "@/stores/userInfo";
import { useCryptoMerchantInfoStore } from "@/stores/CryptoMerchatStore";
import { toMoney } from "@/utils/tool";
import { useLockFn, useRequest ,useMount } from "ahooks";
import { Toast } from "antd-mobile";
import { useMemo,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { level } from "../trade/Earn/data";
/**
 * 使用 Turn Interface to Object 插件去直接成 pagestate
 */
interface PageState {
  amount: string;
  minBuyEach: string;
  paymentType: Payments[];
  isSplit: OrderType;
  payments: Record<Payments, string | number | null>;
  rangeIndex: number | string,
  rangeData: RangeTypes,
}
interface RangeTypes{
  range_start:string,
  range_end:string,
  subsidy_ratio:string
}

const pagestate = {
  amount: "",
  minBuyEach: "",
  paymentType: [],
  isSplit: OrderType.SEPARABLY,
  rangeIndex: "",//超级商家区间选中
  rangeData: {
    range_start:"",
    range_end:"",
    subsidy_ratio:"0",
  },
  payments: {
    [Payments.BANK]: "",
    [Payments.ALI]: "",
    [Payments.WE_CHAT]: "",
    [Payments.CRYPTO_COIN]: "",
    [Payments.DIGITAL_RMB]: "",
    [Payments.WX_GROUP]: "",
  },
};


type ActionType =
  | "update-amount"
  | "update-minBuyEach"
  | "update-isSplit"
  | "update-payments"
  | "update-rangeIndex"
  | "update-rangeData";

const stateReducer: StateReducer<PageState, ActionType> = (state, action) => {
  switch (action.type) {
    case "update-amount":
      return Object.assign({}, state, { amount: action.amount });
    case "update-minBuyEach":
      return Object.assign({}, state, { minBuyEach: action.minBuyEach });
    case "update-isSplit":
      return Object.assign({}, state, { isSplit: action.isSplit });
    case "update-payments":
      console.log(action)
      return Object.assign({}, state, {
        paymentType: action.paymentType,
        payments: action.payments,
      });
    case "update-rangeIndex":
      return Object.assign({}, state, { rangeIndex: action.rangeIndex });
    case "update-rangeData":
      return Object.assign({}, state, { rangeData: action.rangeData });
    default:
      return state;
  }
};

export const useSetup = () => {
  const navigate = useNavigate();
  const { getSourcePath } = useConfigContext();
  const cryptoMerchantStore = useCryptoMerchant()
  const cryptoMerchantInfo = useCryptoMerchantInfoStore((state) => state.cryptoMerchantInfo);
  const getCryptoMerchantInfo = useCryptoMerchantInfoStore((state) => state.getCryptoMerchantInfo);
  const [verifySecurePassword] = useGlobalVerify();
  const [user] = useUserInfoStore()((state) => [state.userInfo]);
  const balance = useMemo(() => {
    return cryptoMerchantStore.isCryptoMerchant ? user.businessBalance : user.validSellBalance
  }, [cryptoMerchantStore.isCryptoMerchant, user.validSellBalance, user.businessBalance])
  const [state, dispatch] = useCreateReducer<PageState, ActionType>(
    stateReducer,
    pagestate,
    {
      ...(cryptoMerchantStore.isPMerchant?{isSplit:1}:{})
    }
  );
  

  useEffect(()=>{
    dispatch({ type: "update-amount", amount: "" });
    dispatch({ type: "update-minBuyEach", minBuyEach: "" });
    dispatch({ type: "update-isSplit", isSplit: 1 });
    dispatch({ type: "update-rangeData", rangeData: {
      range_start:"",
      range_end:"",
      subsidy_ratio:"0",
    }});
  },[cryptoMerchantStore.isPMerchant])


  const levelItem = useMemo(() => {
      return level[cryptoMerchantInfo.level?.matchingLevel || 'DEFAULT'];
  }, [cryptoMerchantInfo])

  const amountList = useMemo(()=>{
    // return cryptoMerchantInfo.professionLevel?.fixedAmount.split(",").filter(v=>v) || [];
    return cryptoMerchantInfo.professionLevel?.fixedAmount || [];
  },[cryptoMerchantInfo])


  useMount(() => {
    if( cryptoMerchantStore.isPMerchant ){
      getCryptoMerchantInfo();//超级商家  获取用户数据  
    }
  })

  const sell = useRequest(
    async (securePassword: string) => {
      const paymentTypeId = Object.keys(state.payments)
        .map((key) => state.payments[Number(key) as Payments])
        .filter((v) => v !== null && v !== undefined && v !== '')
        .join(",");
        console.log(paymentTypeId);
      
      const func = cryptoMerchantStore.isPMerchant ? createProfessionSaleOrder : createSaleOrder;//区分超级商家挂单
      let params = {
        amount: toMoney(state.amount),
        minBuyEach: toMoney(state.minBuyEach),
        paymentType: state.paymentType
          .reduce((previous, current) => {
            if (current && state.payments[current]) {
              return Number(previous) + Number(current)
            }
            return previous;
          }, 0)
          .toString(),
        paymentTypeId:paymentTypeId, 
        isSplit: state.isSplit.toString(),
        maxBuyEach: toMoney(state.amount),
        securePassword,
      }
      if(cryptoMerchantStore.isPMerchant){
        params.minBuyEach =  toMoney(state.rangeData.range_start);
        params.maxBuyEach = toMoney(state.rangeData.range_end);
        params.paymentTypeId = paymentTypeId.split(",")[1]; //超级商家单选 
        params.paymentType = paymentTypeId.split(",")[0]; //超级商家单选 
      }
      Toast.show({
        icon: 'loading',
        duration: 0,
        maskClickable: false,
      })
      const response = await func(params, {
        BusinessStatus: user.BusinessStatus,
        sellerType: cryptoMerchantStore.ApiPath
      });

      if (response.ok) {
        // TODO: 更新用户信息
        Toast.clear()
        if (cryptoMerchantStore.isCryptoMerchant) {

          navigate(`/root/crypto_earn`, { replace: true });
        } else {

          navigate(`/root/home`, { replace: true });
        }
      } else {
        Toast.clear()
        Toast.show(response.msg);
      }
    },
    { manual: true }
  );

  const submit = useLockFn(async () => {
    if (!state.amount) return Toast.show("请输入出售数量");
    if (!/^\d+$/.test(state.amount)) return Toast.show("请输入正确的出售数量");

    if (Number(state.amount) < 10) return Toast.show(`最低出售量为10`);
    if (Number(state.amount) > Number(balance)) {
      return Toast.show(`出售量不得高于可售数量`);
    }
    if (state.paymentType.length === 0) return Toast.show(`请选择支付方式`);

    if( cryptoMerchantStore.isPMerchant){
      if( !state.rangeData.range_start){
        return Toast.show(`请选择购买数量区间`);
      }
      if( Number(state.amount) < Number(state.rangeData.range_end)){
        return Toast.show(`出售量不得低于最高购买量`);
      }
    }

    if (state.isSplit === OrderType.SEPARABLY && !state.minBuyEach) {
      return Toast.show(`请输入最低购买数量`);
    }
    if (state.isSplit === OrderType.SEPARABLY && !/^\d+$/.test(state.minBuyEach)) return Toast.show("请输入正确的最低购买数量");
    if (
      state.isSplit === OrderType.SEPARABLY &&
      Number(state.minBuyEach) > Number(state.amount)
    ) {
      return Toast.show(`最低购买量不得高于出售量`);
    }

    const code = await verifySecurePassword();
    if (code) sell.run(code as string);
  });

  //固定金额点击
  const changeAmount = (rangeIndex:number,val:RangeTypes)=>{
    dispatch({ type: "update-rangeIndex", rangeIndex: rangeIndex });
    dispatch({ type: "update-rangeData", rangeData: val });
    dispatch({ type: "update-minBuyEach", minBuyEach: val.range_start});//设置最低购买金额
    console.log('state1111==',state);
    console.log('state11 val==',val);
  }

  return { 
    state, dispatch, user, getSourcePath, submit, balance,
    isPMerchant:cryptoMerchantStore.isPMerchant, 
    isMerchant:cryptoMerchantStore.isCryptoMerchant,
    levelItem,
    userInfo:cryptoMerchantInfo,
    amountList,
    changeAmount,
    paymentType: 7,
  };
};
